<template>
    <div>
        <SOSlotBase :container-name="'history-withdraw-page-content'">
            <template v-slot:title-bar>
                <SOTitleBar :page-title="'Riwayat Perubahan Upah'" :type="'back'" @back="back" />
            </template>
            <template v-slot:content>
                <div class="p-x-20">
                    <div class="card_breadcrum p-t-16 bg-grey m-x-min">
                        <div class="p-x-20">
                            <SOHeaderList :title="`Layanan: ${namaLayanan}`" />
                        </div>
                    </div>
                    <div class="p-y-20 tl-wrapper">
                        <SOTimeLine v-for="(riwayat, idx) in listRiwayat" :key="`listRiwayat${idx}`">
                            <template v-slot:title>
                                <div class="d-flex align-items-end">
                                    <div class="f-regular f-16 f-c-black m-r-4">
                                        {{ riwayat.title }}
                                    </div>
                                    <div class="f-regular f-14 f-c-midgrey">({{ riwayat.jmlUbah }}x perubahan)</div>
                                </div>
                            </template>
                            <template v-slot:content>
                                <div v-for="(data, key) in riwayat.data" :key="`${idx}data-riwayat${key}`">
                                    <SOTimeLineCard :title="data.title" :id="`${idx}${key}data-riwayat-perubahan`" :isContentShow="true">
                                        <template v-slot:content>
                                            <div class="p-l-12 p-r-12 f-14 f-regular">
                                                <div class="p-y-12 b-d f-c-black">
                                                    <img src="../../assets/icons/info-grey.svg" class="m-r-8" />
                                                    <label class="m-d-0">
                                                        <span>Upah borongan</span>
                                                        <span v-if="data.tipe === 'active'"> diaktifkan.</span>
                                                        <span v-else-if="data.tipe === 'update'"> diubah.</span>
                                                        <span v-else> di-nonaktifkan.</span>
                                                    </label>
                                                </div>

                                                <div
                                                    class="p-y-12 b-d  "
                                                    v-for="(xdt, xidx) in data.data"
                                                    :key="`xdt${xidx}`"
                                                >
                                                    <div>{{ xdt.title }}</div>
                                                    <div class="f-c-midgrey">
                                                        <span>{{ xdt.from }}</span>
                                                        <span> -> </span>
                                                        <span>{{ xdt.to }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </SOTimeLineCard>
                                </div>
                            </template>
                        </SOTimeLine>
                        <div class="flex-1" v-if="listRiwayat.length === 0">
                            <div class="empty-state">
                                <img class="img-fluid" src="@/assets/icons/empty.svg" alt="" />
                                <div class="f-16 f-c-midgrey">
                                    Layanan ini belum memiliki perubahan data apapun.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>

<script>
import conn from "@/store/utils/connection";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOTimeLine from "../../so-components/global/ui/SOTimeline.vue";
import SOTimeLineCard from "../../so-components/global/ui/SOTimelineCard.vue";

export default {
    name: "RiwayatLayananReguler",
    props: {
        namaLayanan: {
            type: String,
            required: true,
        },
        idLayanan: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            listRiwayat: [],
        };
    },
    mounted() {
        this.getRiwayat();
    },
    components: {
        SOTitleBar,
        SOHeaderList,
        SOSlotBase,
        SOTimeLine,
        SOTimeLineCard,
    },
    computed: {
        apiEndPoint() {
            return {
                riwayat: `${this.$baseurl}/masterData/meta/riwayat_upah_tahapan_layanan`,
            };
        },
    },
    methods: {
        back() {
            this.$emit("goToLayanan");
        },
        async getRiwayat() {
            $("#loadingPage").show();
            $("#loadingPage").addClass("overlayLoading");
            try {
                const response = await conn.get(this.apiEndPoint.riwayat, {
                    idlayanan: this.idLayanan,
                });
                if (response.status === 200) {
                    if (response.data.status === true) {
                        this.setListRiwayat(response.data.data);
                    }
                }
                $("#loadingPage").hide();
                $("#loadingPage").removeClass("overlayLoading");
            } catch (e) {
                this.$catch_error_response(e);
                $("#loadingPage").hide();
                $("#loadingPage").removeClass("overlayLoading");
            }
        },
        setListRiwayat(data) {
            this.listRiwayat = [];
            let tz = this.getTimezone();
            Object.keys(data).forEach((key) => {
                let keys = key.split("_");
                let date = this.$moment(keys[1], "DD-MM-YYYY");
                let riwayat = {
                    title: `${date.format("dddd")}, ${date.format("DD MMM YYYY")}`,
                    jmlUbah: data[key].total_ubahan,
                    data: [],
                };

                Object.keys(data[key].data).forEach((idx) => {
                    riwayat.data.push({
                        id: `riwayat_data_${idx}`,
                        title: `${idx} ${tz} oleh Owner`,
                        tipe: data[key].data[idx].tipe,
                        data: data[key].data[idx].data,
                    });
                });
                this.listRiwayat.push(riwayat);
            });
        },
    },
};
</script>
